module.exports = __webpack_public_path__ + "static/img/video_account.e40e9d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video_account.png
// module id = sIdO
// module chunks = 1